import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Menu from "../Menu";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";
import useApiUrls from "../../useApiUrls";
import { saveAs } from "file-saver";
import { QRCodeCanvas } from "qrcode.react";
import QRCode from "qrcode";

const UpdateDqrImage = () => {
  const navigate = useNavigate();
  const { id, id2, name } = useParams(); // Get the campaign ID from the URL
  const { getUrlByOperation } = useApiUrls();

  const canvasRef = useRef(null);
  const imgRef = useRef(null);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [qrCodeValue, setQrCodeValue] = useState("");
  const [DQRImageStructure, setDQRImageStructure] = useState({ data: [] });

  const token = getCookie("token") || getCookie("authToken");
  const userid = getCookie("userid") || getCookie("userId");

  // State to hold form data
  const [formData, setFormData] = useState({
    remark: "",
    ImageCatagory: "Select",
    images: null,
    center: false,
    center2: false,
    imagepositionx: "",
    imagepositiony: "",
    imagewidth: "",
    imageheight: "",
    exampletext: "",
    fontfamily: "Select",
    fontsize: "",
    textpositionx: "",
    textpositiony: "",
    fontcolor: "",
    addqr: "",
  });

  useEffect(() => {
    const fetchDQRStrucureData = async () => {
      try {
        

        const response = await axios.get(
          `https://api.dqr-display-tms.eventum.co.in/api/DQRImageStructureOperation/Get/DqrId/DqrCategoryId/${id}/${id2}`,
          {
            headers: {
              accept: "text/plain",
              "X-Authorization": token,
              UserId: userid,
            },
          }
        );
        // if (catalogResponse.data && Array.isArray(catalogResponse.data.data)) {
        //   setFormData({ data: catalogResponse.data.data });
        // }

        if (response.data && Array.isArray(response.data.data)) {
          setFormData({
            ...response.data.data[0],
            // active: response.data.data[0].active === "Active" // Convert to boolean
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchDQRStrucureData();
  }, [id, id2]);



  // State to hold API response or error
  const [message, setMessage] = useState("");
  // State to control the visibility of the popup
  const [showPopup, setShowPopup] = useState(false);

  // Function to handle the popup close
  const handleClosePopup = () => {
    setShowPopup(false);
  };

  // Function to handle the popup open
  const handleOpenPopup = () => {
    setShowPopup(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the form from refreshing the page
    
    
  const token = getCookie("token");
  const userid = getCookie("userid");

    // Create an object with only the fields that should be sent in the update request
    const payload = {
      remark: String(formData.remark ?? ""),
      dqrid: Number(id),
      dqrcategoryid: Number(id2),
      addqr: String(formData.addqr ?? ""),
      imagewidth: String(formData.imagewidth ?? ""),
      imageheight: String(formData.imageheight ?? ""),
      center: String(formData.center ?? ""),
      imagepositionx: String(formData.imagepositionx ?? ""),
      imagepositiony: String(formData.imagepositiony ?? ""),
      exampletext: String(formData.exampletext ?? ""),
      fontfamily: String(formData.fontfamily ?? ""),
      fontcolor: String(formData.fontcolor ?? ""),
      fontsize: String(formData.fontsize ?? ""),
      textpositionx: String(formData.textpositionx ?? ""),
      textpositiony: String(formData.textpositiony ?? ""),
    };

    try {
      // Insert new or Update existing based on presence of formData.id
      const isUpdate = Boolean(formData && formData.id);
      const endpoint = isUpdate
        ? "https://api.dqr-display-tms.eventum.co.in/api/DQRImageStructureOperation/Update"
        : "https://api.dqr-display-tms.eventum.co.in/api/DQRImageStructureOperation/Insert";
      const body = isUpdate ? { ...payload, id: formData.id } : payload;

      await axios.post(
        endpoint,
        body,
        {
          headers: {
            accept: "text/plain",
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
          },
        }
      );
      setMessage(
        isUpdate
          ? "DQR image structure updated successfully!"
          : "DQR image structure inserted successfully!"
      );

      // Set a delay before navigating
      setTimeout(() => {
        navigate(`/show-dqr-images/${id}/${id2}`);
      }, 3000);
    } catch (error) {
      console.error("Error saving DQR image structure:", error);
      setMessage("Failed to save DQR image structure.");
    }
  };

  const handlePreview = async (e) => {
    e.preventDefault();

    if (!imageLoaded) {
      alert("Please wait for the image to load before previewing.");
      return;
    }

    setShowPopup(true); // This will trigger the useEffect which draws the canvas.
  };

  // Handle input change for text and file inputs separately
  const handleChange = (e) => {
    const { name, value, type, files, checked } = e.target;

    if (type === "file") {
      const file = files && files[0] ? files[0] : null;
      setFormData((prevData) => ({
        ...prevData,
        [name]: file,
      }));

      if (file) {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          imgRef.current = img;
          setImageLoaded(true);
        };
      }
      return;
    }

    if (type === "checkbox") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: checked,
      }));
      return;
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const drawCanvas = () => {
    setTimeout(() => {
      const canvas = canvasRef.current;
      if (canvas && imgRef.current && imageLoaded) {
        const ctx = canvas.getContext("2d");
        console.log("Drawing on canvas with loaded image");

        // Clear the canvas
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Draw image on the canvas
        ctx.drawImage(imgRef.current, 0, 0, 320, 480);

        // Draw text on the canvas
        const fontsize = parseInt(formData.fontsize, 10);
        const fontfamily = formData.fontfamily;
        const textpositionx = parseFloat(formData.textpositionx);
        const textpositiony = parseFloat(formData.textpositiony);

        if (!isNaN(fontsize) && fontfamily) {
          ctx.font = `${fontsize}px ${fontfamily}`;
          ctx.fillStyle = formData.fontcolor || "black";
          ctx.fillText(formData.exampletext, textpositionx, textpositiony);
        }

        // Draw QR Code if addqr is provided
        if (formData.addqr) {
          const qrCodeCanvas = document.createElement("canvas");
          qrCodeCanvas.width = parseFloat(formData.imagewidth) || 100;
          qrCodeCanvas.height = parseFloat(formData.imageheight) || 100;

          // Generate the QR code
          QRCode.toCanvas(
            qrCodeCanvas,
            formData.addqr,
            { width: qrCodeCanvas.width },
            (error) => {
              if (error) {
                console.error(error);
                return;
              }
              // Draw the generated QR code onto the main canvas
              const qrCodePositionX = formData.imagepositionx
                ? parseFloat(formData.imagepositionx)
                : 0;
              const qrCodePositionY = formData.imagepositiony
                ? parseFloat(formData.imagepositiony)
                : 0;
              ctx.drawImage(
                qrCodeCanvas,
                qrCodePositionX,
                qrCodePositionY,
                qrCodeCanvas.width,
                qrCodeCanvas.height
              );
            }
          );
        }
      } else {
        console.error("Canvas or image not available for drawing");
      }
    }, 50); // Optional small delay to ensure all rendering is ready.
  };

  useEffect(() => {
    if (imageLoaded && canvasRef) {
      drawCanvas();
    }
  }, [imageLoaded, canvasRef, formData]);

  const downloadCanvasAsJPG = () => {
    const canvas = canvasRef.current;
    canvas.toBlob(
      (blob) => {
        saveAs(blob, "canvas-image.jpg");
      },
      "image/jpeg",
      1.0
    );
  };

  const [text, setText] = useState("");
  const [isBold, setIsBold] = useState(false);
  const [isItalic, setIsItalic] = useState(false);
  const [isUnderline, setIsUnderline] = useState(false);

  const handleTextChange = (e) => {
    setText(e.target.value);
  };

  const toggleBold = () => {
    setIsBold(!isBold);
  };

  const toggleItalic = () => {
    setIsItalic(!isItalic);
  };

  const toggleUnderline = () => {
    setIsUnderline(!isUnderline);
  };

  const getStyle = () => {
    let style = {};
    if (isBold) style.fontWeight = "bold";
    if (isItalic) style.fontStyle = "italic";
    if (isUnderline) style.textDecoration = "underline";
    return style;
  };

  const generateQRCode = () => {
    setQrCodeValue(formData.addqr);
  };

  useEffect(() => {
    if (showPopup && imageLoaded && canvasRef.current) {
      drawCanvas();
    }
  }, [showPopup, imageLoaded]);

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Update DQR Image</h3>
                    </div>
                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Image</label>
                              <input
                                type="file"
                                className="form-control"
                                onChange={handleChange}
                                name="images"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Image Catagory</label>
                              <select
                                className="form-control"
                                name="ImageCatagory"
                                value={formData.ImageCatagory}
                                onChange={handleChange}
                              >
                                <option value="Select">Select</option>
                                <option value={true}>Welcome Image</option>
                                <option value={false}>QR Image</option>
                                <option>Success Image</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.remark}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="remark"
                              />
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Add Qr</label>
                              <input
                                type="url"
                                className="form-control"
                                onChange={handleChange}
                                name="addqr"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Image Width</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.imagewidth}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="imagewidth"
                              />
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Image Height</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.imageheight}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="imageheight"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-2">
                            <div className="form-group">
                              <label>Center</label>
                              <input
                                type="checkbox"
                                className="form-control"
                                checked={formData.center}
                                onChange={handleChange}
                                name="center"
                              />
                            </div>
                          </div>

                          <div className="col-sm-5">
                            <div className="form-group">
                              <label>Image position - x</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.imagepositionx}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="imagepositionx"
                              />
                            </div>
                          </div>

                          <div className="col-sm-5">
                            <div className="form-group">
                              <label>Image position - y</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.imagepositiony}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="imagepositiony"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Example Text</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.exampletext}
                                onChange={handleChange}
                                name="exampletext"
                                placeholder="Enter ..."
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Font Family</label>
                              <select
                                className="form-control"
                                name="fontfamily"
                                value={formData.fontfamily}
                                onChange={handleChange}
                              >
                                <option value="Select">Select</option>
                                <option
                                  value="Arial"
                                  style={{ fontfamily: "Arial" }}
                                >
                                  Arial
                                </option>
                                <option
                                  value="Verdana"
                                  style={{ fontfamily: "Verdana" }}
                                >
                                  Verdana
                                </option>
                                <option
                                  value="Times New Roman"
                                  style={{ fontfamily: "Times New Roman" }}
                                >
                                  Times New Roman
                                </option>
                                <option
                                  value="Georgia"
                                  style={{ fontfamily: "Georgia" }}
                                >
                                  Georgia
                                </option>
                                <option
                                  value="Garamond"
                                  style={{ fontfamily: "Garamond" }}
                                >
                                  Garamond
                                </option>
                                <option
                                  value="Courier New"
                                  style={{ fontfamily: "Courier New" }}
                                >
                                  Courier New
                                </option>
                                <option
                                  value="Brush Script MT"
                                  style={{ fontfamily: "Brush Script MT" }}
                                >
                                  Brush Script MT
                                </option>
                              </select>
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Text Size</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.fontsize}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="fontsize"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Text position - x</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.textpositionx}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="textpositionx"
                              />
                            </div>
                          </div>

                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Text position - y</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.textpositiony}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="textpositiony"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Font Color</label>
                              <input
                                type="color"
                                className="form-control"
                                value={formData.fontcolor}
                                onChange={handleChange}
                                name="fontcolor"
                                placeholder="Enter ..."
                              />
                            </div>
                          </div>
                          <div
                            className="buttons"
                            style={{
                              marginTop: "27px",
                              marginLeft: "10px",
                              height: "10px",
                            }}
                          ></div>
                        </div>

                        <div className="card-footer">
                          <button type="submit" className="btn btn-info">
                            Update
                          </button>
                          <button
                            type="button"
                            className="btn btn-success ml-2"
                            onClick={handlePreview}
                            disabled={!imageLoaded} // Disable until the image is loaded
                          >
                            Preview
                          </button>

                          <button
                            type="button"
                            className="btn btn-secondary ml-2"
                            onClick={downloadCanvasAsJPG}
                          >
                            Download as JPG
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div>
                  <div style={getStyle()}>{text}</div>
                </div>
                <div></div>
              </div>
            </div>
          </section>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {showPopup && (
              <div
                className="popup"
                style={{
                  backgroundColor: "white",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  padding: "20px",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                }}
              >
                <div className="popup-content">
                  <span
                    className="close"
                    onClick={handleClosePopup}
                    style={{
                      cursor: "pointer",
                      float: "right",
                      fontSize: "20px",
                    }}
                  >
                    &times;
                  </span>
                  <canvas ref={canvasRef} width="320" height="480"></canvas>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateDqrImage;
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
